import React from "react"

const RouteHistoryContext = React.createContext()

export default RouteHistoryContext
